import type { ViewStyle } from 'react-native'
import type { ThemeMode } from '../hooks/useTheme'

export interface AttackLogAppearance {
  background: string
  border: string
  borderWidth?: number
  borderStyle?: ViewStyle['borderStyle']
  radius?: number
  accent?: string
  shadow?: string
  inset?: boolean
  rules?: boolean
}

/** Selected report treatment: Recessed report, shared with its QA preview. */
export const ATTACK_LOG_APPEARANCE: Record<ThemeMode, AttackLogAppearance> = {
  light: { background: '#e8dfc7', border: '#ada07a', shadow: 'inset 0 2px 4px #70684422', inset: true },
  dark: { background: '#161d12', border: '#56613e', shadow: 'inset 0 2px 5px #00000055', inset: true },
}
